// Tracks whether the next article opened in the reader was opened by an
// explicit user action (clicking a row, pressing Enter/Space, double-clicking)
// as opposed to arrow-key browsing through the list. When set, ReaderColumn
// moves focus into the reader content once it's ready so screen-reader users
// land on the article instead of remaining in the list. Arrow-key browsing
// deliberately does NOT request focus, so the cursor stays in the list.
//
// Module store (like scrollRestoreStore) rather than context: the request
// originates deep in a bookmark row and is consumed by the reader column on a
// later render, so an imperative signal is simpler than threading state.

let pendingFocusId: string | null = null;

/** Request that the reader take focus the next time `bookmarkId` is opened. */
function requestReaderFocus(bookmarkId: string): void {
  pendingFocusId = String(bookmarkId);
}

/**
 * Returns true (and clears the request) if focus was requested for `bookmarkId`.
 * Returns false if no request is pending or it targets a different bookmark.
 */
function consumeReaderFocus(bookmarkId: string): boolean {
  if (pendingFocusId !== null && pendingFocusId === String(bookmarkId)) {
    pendingFocusId = null;
    return true;
  }
  return false;
}

/** Discard any pending focus request. */
function clearReaderFocus(): void {
  pendingFocusId = null;
}

export { requestReaderFocus, consumeReaderFocus, clearReaderFocus };
